import { twMerge } from "tailwind-merge";
import clsx from "clsx";

export function Table({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  return (
    <div className="w-full overflow-x-auto">
      <table className={twMerge("w-full text-sm border-collapse", className)}>{children}</table>
    </div>
  );
}

export function THead({ children }: React.PropsWithChildren) {
  return <thead className="bg-surface-50 text-xs uppercase tracking-wide text-surface-500">{children}</thead>;
}

export function TR({ children, className, onClick }: React.PropsWithChildren<{ className?: string; onClick?: () => void }>) {
  return (
    <tr onClick={onClick} className={twMerge(clsx(
      "border-b border-surface-100 last:border-0",
      onClick && "hover:bg-surface-50 cursor-pointer transition-colors",
      className,
    ))}>{children}</tr>
  );
}

export function TH({ children, className }: React.PropsWithChildren<{ className?: string }>) {
  return <th className={twMerge("text-left font-semibold px-4 py-3", className)}>{children}</th>;
}

export function TD({ children, className, title }: React.PropsWithChildren<{ className?: string; title?: string }>) {
  return <td className={twMerge("px-4 py-3 text-surface-800", className)} title={title}>{children}</td>;
}


